import { render, staticRenderFns } from "./AccountMyNotes.vue?vue&type=template&id=8a24f29c&scoped=true&"
import script from "./AccountMyNotes.vue?vue&type=script&lang=js&"
export * from "./AccountMyNotes.vue?vue&type=script&lang=js&"
import style0 from "./AccountMyNotes.vue?vue&type=style&index=0&id=8a24f29c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a24f29c",
  null
  
)

export default component.exports